module.exports = "./img/247c895787e90234ce5b420b874640ec.jpg";